import { action, observable } from 'mobx';
import moment from 'moment';

class CalendarStore{
    @observable accessor events = [];
    @observable accessor dateRange = null;
    @observable accessor date = moment.utc().format("YYYY-MM-DD");
    @observable accessor eventOrder = 'title';

    constructor({eventActions, editable = true}){

        this.onEventDrop = eventActions.onDrop;
        this.onEventClick = eventActions.onClick;
        this.onEventsFetch = eventActions.onFetch;
        this.onEventRender = eventActions.onRender;
        this.onDayRender = eventActions.onDayRender;
        this.onEventPositioned = eventActions.onPositioned;
        this.editable = editable;
    }

    @action.bound
    setEventOrder(order) {
        this.eventOrder = order;
    }

    @action.bound
    setEvents(events) {
        this.events = events;
    }

    @action.bound
    setDateRange(dateFrom, dateTo) {
        this.dateRange = { 
            from: dateFrom,
            to: dateTo
        };
    }

    @action.bound
    setDate(date) {
        this.date = moment(date).format("YYYY-MM-DD");
    }

    @action.bound
    mouseMoveListener(e) {
        var scrollableElement = document.getElementsByClassName('layout__content');
        if((window.innerHeight - e.y < 100 && e.movementY > 0) ||
            e.y < 100 && e.movementY < 0)
        {
            scrollableElement[0].scrollTo(0, scrollableElement[0].scrollTop +( e.movementY * 70));            
}
    }

    @action.bound
    onEventDragStart() {
        document.body.addEventListener('mousemove', this.mouseMoveListener);
    }

    @action.bound
    onEventDragStop() {
        document.body.removeEventListener('mousemove', this.mouseMoveListener);        
    }
}

export default CalendarStore;
